import React from "react";
import {cart} from "./cart";
import {CartRowService} from "../cart/cart-row-service";
export {CartRow};

class CartRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleAddProduct = this.handleAddProduct.bind(this);
        this.state = {quantity: this.props.item.quantity, quantity_prev: this.props.item.quantity, services_toggle: 0};
        this.upQuantity = this.upQuantity.bind(this);
        this.downQuantity = this.downQuantity.bind(this);
        this.serviceToggle = this.serviceToggle.bind(this);
    }

    handleAddProduct(e){
        this.props.handleAddProduct(e);
    }

    upQuantity(){
        const quantity = this.state.quantity;
        this.setState({quantity: quantity + 1, quantity_prev: quantity});
        this.updateQuantity(quantity + 1, quantity);
    }

    downQuantity(){
        const quantity = this.state.quantity;
        if(quantity > 1){
            this.setState({quantity: quantity - 1, quantity_prev: quantity});
            this.updateQuantity(quantity - 1, quantity);
        }
    }

    deleteService(product_id){
        let services = null;
        if(this.props.item.additional_services && this.props.item.additional_services.length){
            services = this.props.item.additional_services.map((item) => item.product_id == product_id ? null : item.product_id);
        }

        event = 'remove_from_cart';

        let items = dataLay.getObjectsReact(this.props.item);

        dataLay.sendData(items, event);

        if(this.props.item.assembly_id){
            cart.updateAssembly(this.props.item.assembly_id, parseInt(this.props.item.quantity), null, services, this.props.onUpdate);
        }else{
            cart.updateProduct(this.props.item.product_id, parseInt(this.props.item.quantity), null, null, this.props.item.bundle_id, services, this.props.onUpdate);
        }

    }

    serviceToggle(service_id, group_id, category_id, bundle_id){
        let services = [];
        $('#cart' + this.props.item.product_id + ' :checked').map((index, elem) => services.push(elem.value));
        console.log(this.props.item);
        /*
        let services = this.getServices();
        if(!services[category_id]){
            services[category_id] = [];
        }
        if(!services[category_id][group_id]){
            services[category_id][group_id] = [];
        }

        if(services[category_id] && services[category_id][group_id] == service_id){
            delete services[category_id][group_id];
            let event = 'remove_from_cart';
        }else{
            services[category_id][group_id] = service_id;
            let event = 'add_to_cart';
        }

        this.setState({services: services});
        */
        if(this.props.item.assembly_id){
            cart.updateAssembly(this.props.item.assembly_id, parseInt(this.props.item.quantity), null, services, this.props.onUpdate);
        }else{
            let assembly_id = this.props.item.assem_id;
            cart.updateProduct(this.props.item.product_id, parseInt(this.props.item.quantity), null, assembly_id, bundle_id, services, this.props.onUpdate);
        }

    }

   updateQuantity(quantity, quantity_prev){
        let services = this.getServices(this.props.item);

        let event = 'add_to_cart';
        if(quantity_prev > quantity){
            event = 'remove_from_cart';
        }

        let items = dataLay.getObjectsReact(this.props.item);

        dataLay.sendData(items, event);

        if(this.props.item.assembly_id) {
            cart.updateAssembly(this.props.item.assembly_id, parseInt(quantity), null, services, this.props.onUpdate);
        }else if(this.props.item.bundle_id){
            cart.updateBundle(this.props.item.bundle_id, parseInt(quantity), this.props.onUpdate);
        }else{
            cart.updateProduct(this.props.item.product_id, parseInt(quantity), null, null,null, services, this.props.onUpdate);
        }


        if(parseInt(quantity) == 0){
            var dataL = {
                'event':'MTRENDO',
                'eventCategory': 'EEC',
                'eventAction':'remove_from_cart',
                'eventLabel': this.props.item.name,
                'product-list': this.props.list,
                'products': [{
                    'name': this.props.item.name,
                    'id': this.props.item.assembly_id ? 'assembly_' + this.props.item.assembly_id : this.props.item.product_id,
                    'articul': this.props.item.code,
                    'price': this.props.item.price,
                    'category': this.props.item.categories_path,
                    'list': this.props.list,
                    'variant':  '',
                    'brand': this.props.item.brand,
                    'position': this.props.position,
                    'quantity': this.state.quantity
                }]
            };

            window.dataLayer.push(dataL);
        }
    }

    getServices(product){
        if(typeof product.additional_services != 'undefined'){
            return product.additional_services.flatMap((elem) => {
                if (elem.additional_service_consumables.length){
                    return elem.additional_service_consumables.map((service_product) => {
                        return elem.product_id + ',' + service_product.product_id;
                    })
                }else{
                    return elem.product_id;
                }

            });
        }

    }

    render() {
        let item = this.props.item;
        if(item.promo_code_price){
            if(item.price_prev){
                item.price = item.promo_code_price;
            }else{
                item.price_prev = item.price;
                item.price = item.promo_code_price;
            }
        }

        let services = this.getServices(item);
        let services_price = 0;
        if(typeof item.additional_services != 'undefined') {
            services_price = item.additional_services.reduce((sum, elem) => sum + elem.price  + (elem.additional_service_consumables.length ? elem.additional_service_consumables.reduce((sum, elem) => sum + elem.price , 0) : 0), 0);
            //services_price = item.additional_services.reduce((sum, elem) => sum + elem.price * item.quantity + (elem.additional_service_consumables.length ? elem.additional_service_consumables.reduce((sum, elem) => sum + elem.price * item.quantity , 0) : 0), 0);
        }

        if (this.props.item.assembly_id){
            return (
                <div className="thanks-page__kit thanks-page__kit_economy">
                    <div className="thanks-page__kit-header">
                        <div className="thanks-page__kit-header-column thanks-page__kit-header-column_left">
                            <div className="thanks-page__kit-title">{lajax.t('Сборка')} {item.assembly_id}</div>

                            {/*<div className="thanks-page__kit-type thanks-page__kit-type_economy">Экономия 2 955 ₴</div>*/}
                        </div>
                        <div className="thanks-page__kit-header-column thanks-page__kit-header-column_right">
                            <div className="product-counter product-counter_size-26">
                                <form className="product-counter__form">
                                    <button className="product-counter__btn product-counter__btn_subtract"
                                            onClick={() => this.downQuantity()}
                                            type="button"></button>
                                    <input className="form-control" type="text"
                                           value={this.state.quantity}
                                           readOnly={true}
                                    />
                                    <button className="product-counter__btn product-counter__btn_plus"
                                            onClick={() => this.upQuantity()}
                                            type="button"></button>

                                </form>
                            </div>
                            <If condition={item.price_prev}>
                                <div className="thanks-page__kit-price thanks-page__kit-price_old">{tools.displayPrice(item.price_prev)} ₴</div>
                                <div className="thanks-page__kit-price thanks-page__kit-price_new">{tools.displayPrice(item.price)} ₴</div>
                            </If>
                            <If condition={!item.price_prev}>
                                <div className="thanks-page__kit-price">{tools.displayPrice(item.price)}</div>
                            </If>

                            <div className="dots-block dropdown dropdown-controls">
                                <button className="btn dropdown-toggle btn-controls" data-bs-toggle="dropdown"
                                        aria-expanded="false"></button>
                                <ul className="dropdown-menu dropdown-menu-controls">
                                    <li className="dropdown-menu-li">
                                        <a className="dropdown-item dropdown-item_remove"
                                        onClick={() => this.updateQuantity(0, item.quantity)}>{lajax.t('Удалить')}</a></li>
                                    <li className="dropdown-menu-li"><a className="dropdown-item dropdown-item_rename" href={baseUrl + "assembly/upgrade/?id_assembly=" + this.props.item.assembly_id}>{lajax.t('Редагувати збірку')}</a></li>
                                </ul>
                                <div className="dots-block__dropdown"></div>
                            </div>
                        </div>
                    </div>
                    {item.complectation.map((compl, i) => {
                        compl.assem_id = item.assembly_id;
                        return (
                            <CartRow
                                item={compl}
                                key={"cartrow" + item.assembly_id + '-'+compl.id}
                                onUpdate={this.props.onUpdate}
                                assemblyProduct={true}
                                position={this.props.position}
                                bundle_id={0}
                            />
                        );
                    })}
                </div>
            )
        }else if (this.props.item.bundle_id){
            return (
                <div className="thanks-page__kit thanks-page__kit_economy">
                    <div className="thanks-page__kit-header">
                        <div className="thanks-page__kit-header-column thanks-page__kit-header-column_left">
                            <div className="thanks-page__kit-title">{lajax.t('Комплект')} {item.bundle_id}</div>

                            {/*<div className="thanks-page__kit-type thanks-page__kit-type_economy">Экономия 2 955 ₴</div>*/}
                        </div>
                        <div className="thanks-page__kit-header-column thanks-page__kit-header-column_right">
                            <div className="product-counter product-counter_size-26">
                                <form className="product-counter__form">
                                    <button className="product-counter__btn product-counter__btn_subtract"
                                            onClick={() => this.downQuantity()}
                                            type="button"></button>
                                    <input className="form-control" type="text"
                                           value={this.state.quantity}
                                           readOnly={true}
                                    />
                                    <button className="product-counter__btn product-counter__btn_plus"
                                            onClick={() => this.upQuantity()}
                                            type="button"></button>

                                </form>
                            </div>
                            <If condition={item.price_prev && item.price}>
                                <div className="thanks-page__kit-price thanks-page__kit-price_old">{tools.displayPrice(item.price_prev)} ₴</div>
                                <div className="thanks-page__kit-price thanks-page__kit-price_new">{tools.displayPrice(item.price)} ₴</div>
                            </If>
                            <If condition={!item.price_prev}>
                                <div className="thanks-page__kit-price">{tools.displayPrice(item.price)}</div>
                            </If>
                            <div className="dots-block dropdown dropdown-controls">
                                <button className="btn dropdown-toggle btn-controls" data-bs-toggle="dropdown"
                                        aria-expanded="false"></button>
                                <ul className="dropdown-menu dropdown-menu-controls">
                                    <li className="dropdown-menu-li">
                                        <a className="dropdown-item dropdown-item_remove"
                                           onClick={() => this.updateQuantity(0, item.quantity)}>{lajax.t('Удалить')}</a></li>
                                    {/*}
                                    <li className="dropdown-menu-li"><a className="dropdown-item dropdown-item_rename"
                                                                        href="#">Редактировать сборку</a></li>
                                    */}
                                </ul>
                                <div className="dots-block__dropdown"></div>
                            </div>
                        </div>
                    </div>
                    {item.complectation.map((compl, i) => {
                        compl.assem_id = item.assembly_id;
                        return (
                            <CartRow
                                item={compl}
                                key={"cartrow" + item.bundle_id + '-' + compl.id}
                                onUpdate={this.props.onUpdate}
                                assemblyProduct={true}
                                position={this.props.position}
                                bundle_id={this.props.item.bundle_id}
                            />
                        );
                    })}
                </div>
            )
        }else{

            return (
                <div className="thanks-page__product" id={"cart" + item.product_id}>
                    <div className={"thanks-page__product-row" + (!this.props.assemblyProduct || item.bonuses_to_charge ? " thanks-page__product-row-hd align-center" : "")}>
                        <div className="thanks-page__product-picture">
                            <img className="img-fluid" src={item.image_small} loading="lazy"/>
                        </div>
                        <If condition={isMobile}>
                            <a className="thanks-page__product-title" href={tools.getProductLink(item.link_rewrite)}>{item.fullname_lang}</a>


                            <div className="thanks-page__product-row mb-0">
                                <If condition={!this.props.assemblyProduct && !item.bonuses_to_charge}>
                                    <div className="thanks-page__product-bonus-null"></div>
                                </If>
                                <If condition={item.bonuses_to_charge}>
                                    <div className="thanks-page__product-bonus">+{item.bonuses_to_charge}</div>
                                </If>
                                <If condition={!this.props.assemblyProduct}>
                                    <div className="thanks-page__product-column pr-0">
                                        <div className="product-counter product-counter_size-26">
                                            <form className="product-counter__form">
                                                <button className="product-counter__btn product-counter__btn_subtract"
                                                        onClick={() => this.downQuantity()}
                                                        type="button"></button>
                                                <input className="form-control" type="text"
                                                       value={this.state.quantity}
                                                       readOnly={true}
                                                />
                                                <button className="product-counter__btn product-counter__btn_plus"
                                                        onClick={() => this.upQuantity()}
                                                        type="button"></button>
                                            </form>
                                        </div>
                                    </div>
                                </If>
                                <div className="thanks-page__product-price">
                                    <If condition={item.price_prev}>
                                        <div className="thanks-page__product-price-item thanks-page__product-price-item_old">
                                            <span>{tools.displayPrice(item.price_prev)}</span> ₴
                                        </div>
                                        <div className="thanks-page__product-price-item thanks-page__product-price-item_new">
                                            <span><If condition={this.props.assemblyProduct && item.quantity > 1}><small>{item.quantity}&times;</small></If>{tools.displayPrice(item.price)}</span> ₴
                                        </div>
                                    </If>
                                    <If condition={!item.price_prev}>
                                        <div className="thanks-page__product-price-item">
                                            <span><If condition={this.props.assemblyProduct && item.quantity > 1}><small>{item.quantity}&times;</small></If>{tools.displayPrice(item.price)}</span> ₴
                                        </div>
                                    </If>
                                </div>
                            </div>
                            <If condition={!this.props.assemblyProduct}>
                                <button className="thanks-page__product-btn thanks-page__product-btn_delete" type="button"
                                        onClick={(e) => this.updateQuantity(0, item.quantity)}></button>
                            </If>
                        </If>
                        <If condition={!isMobile}>
                            <div className="thanks-page__product-column">
                                <a className="thanks-page__product-title" href={tools.getProductLink(item.link_rewrite)}>{item.fullname_lang}</a>
                            </div>
                            <If condition={item.bonuses_to_charge}>
                                <div className="thanks-page__product-bonus">+{item.bonuses_to_charge}</div>
                            </If>
                            <If condition={!this.props.assemblyProduct && !item.bonuses_to_charge}>
                                <div className="thanks-page__product-bonus-null"></div>
                            </If>

                            <If condition={!this.props.assemblyProduct}>
                                <div className="product-counter product-counter_size-26">
                                    <form className="product-counter__form">
                                        <button className="product-counter__btn product-counter__btn_subtract"
                                                onClick={() => this.downQuantity()}
                                                type="button"></button>
                                        <input className="form-control" type="text"
                                               value={this.state.quantity}
                                               readOnly={true}
                                        />
                                        <button className="product-counter__btn product-counter__btn_plus"
                                                onClick={() => this.upQuantity()}
                                                type="button"></button>
                                    </form>

                                </div>
                            </If>
                            <div className="thanks-page__product-price">
                                <If condition={item.price_prev}>
                                    <div className="thanks-page__product-price-item thanks-page__product-price-item_old">
                                        <span>{tools.displayPrice(item.price_prev)}</span> ₴
                                    </div>
                                    <div className="thanks-page__product-price-item thanks-page__product-price-item_new">
                                        <span><If condition={this.props.assemblyProduct && item.quantity > 1}><small>{item.quantity}&times;</small></If>{tools.displayPrice(this.props.item.price)}</span> ₴
                                    </div>
                                </If>
                                <If condition={!item.price_prev}>
                                    <div className="thanks-page__product-price-item">
                                        <span><If condition={this.props.assemblyProduct && item.quantity > 1}><small>{item.quantity}&times;</small></If>{tools.displayPrice(item.price)}</span> ₴
                                    </div>
                                </If>

                            </div>
                            <If condition={!this.props.assemblyProduct}>
                            <button className="thanks-page__product-btn thanks-page__product-btn_delete" type="button"
                                    onClick={(e) => this.updateQuantity(0, item.quantity)}></button>
                            </If>
                        </If>
                    </div>
                    <If condition={item.partial_pay}>
                    <div className="thanks-page__product-row thanks-page__product-row_padding-left">
                            <div className="thanks-page__product-pay"><strong>{this.props.item.partial_pay} </strong>{lajax.t('мес.')}</div>
                        {/*
                        <div className="thanks-page__product-jaw">{lajax.t('Предоплата')} +150 ₴</div>
                        */}
                    </div>
                    </If>
                    <If condition={item.gifts}>
                        {item.gifts.map(gift => (
                            <div key={gift.id} className="thanks-page__product-row">
                                <div className="thanks-page__product-gift">
                                    <strong>{lajax.t('Подарок')}: </strong>{gift.fullname_lang}
                                </div>
                                <div className="thanks-page__product-price">
                                    <div className="thanks-page__product-price-item">
                                        <span>{tools.displayPrice(gift.price)}</span> ₴
                                    </div>
                                </div>
                            </div>
                        ))}

                    </If>

                    <If condition={item.additional_service_groups.length}>
                    <div className="thanks-page__product-row thanks-page__product-row_padding-left">
                        <a className="link-w-border thanks-page__product-link thanks-page__product-link_arrow"
                        onClick={() => this.setState({services_toggle: !this.state.services_toggle})}>{lajax.t('Сервис')}</a>
                        <If condition={services_price}>
                            <div className="thanks-page__product-service">+{tools.displayPrice(services_price)} ₴</div>
                        </If>
                    </div>
                    <div className="thanks-page__product-row_padding-left">
                        <div className={"collapse" + (this.state.services_toggle ? " show" : "")} id="data_service_2">
                            <div className="data-services-list">
                                {item.additional_service_groups.map((group) => (
                                    <React.Fragment key={group.id}>
                                        <CartRowService
                                            group={group}
                                            product={item}
                                            services={services}
                                            handleServiceToggle={this.serviceToggle}
                                            position={this.props.position}
                                            bundle_id={this.props.bundle_id}
                                        />
                                    </React.Fragment>
                                ))}

                            </div>
                        </div>
                    </div>
                    </If>

                    {/*
                    <If condition={item.additional_services}>
                    {item.additional_services.map(service => (
                        <div key={service.id} className="thanks-page__product-row">
                            <div className="thanks-page__product-descr">{tools.getLangField(service, 'name_full')}</div>
                            <div className="thanks-page__product-price">
                                <div className="thanks-page__product-price-item">{tools.displayPrice(service.price)} ₴</div>
                            </div>
                            <button className="thanks-page__product-btn thanks-page__product-btn_delete" type="button"
                                    onClick={(e) => this.deleteService(service.product_id)}></button>
                        </div>
                    ))}
                    </If>
                    */}
                </div>
            );
        }
    }
}